import request from '@/utils/request'

// export function getStandingsList(data) {
//     return request({
//         url: '/v1/case/standings/',
//         method: 'post',
//         data:data
//     })
// }

export function getRanktimeList() {
    return request({
      url: 'v1/case/getRankTimeList',
      // url: '/system/article/case',
      method: 'get',
    })
  }
  

  
// 获取战队排名列表（按地区+日期查询）
export function getStandingsList(params) {
  return request({
    url: '/v1/standing/list',  // 后端接口
    method: 'get',
    params: params            // region、rankDate、teamName
  })
}

// 获取战队排名走势数据
export function getTeamRankingTrend(params) {
  return request({
    url: '/v1/standing/trend',  // 后端接口
    method: 'get',
    params: params            // region、teamName、startDate、endDate
  })
}

// api/standings.js
export function getTeamList(params) {
  return request({
    url: '/v1/standing/teams',
    method: 'get',
    params // region
  })
}
export function getStandingsTop10(params) {
  return request({
    url: '/v1/standing/top10',  // 后端接口
    method: 'get',
    params: params            // region、rankDate、teamName
  })
}